import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getApiBaseUrl, getAuthToken } from '../../../services/api';

const API_BASE = () => `${getApiBaseUrl()}/api/admin/resources`;

const NotificationsTab = () => {
  const { t } = useTranslation('resourcesManagement');
  const [message, setMessage] = useState('');
  const [segment, setSegment] = useState('all');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState('');

  const handleSend = () => {
    setSending(true);
    setResult('');
    const token = getAuthToken();
    if (!token) return setResult('Not authenticated');
    fetch(`${API_BASE()}/notify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ type: 'email', segment, message }),
    })
      .then((r) => r.json())
      .then((data) => setResult(data.message || (data.success ? 'Queued (stub).' : 'Failed')))
      .catch((e) => setResult(e.message))
      .finally(() => setSending(false));
  };

  return (
    <div className="tab-content">
      <p>Notify users when new exams are added. Email/push queue can be wired to your notification service.</p>
      <div className="resources-form-card">
        <div className="resources-form-group">
          <label>{t('notifications.segment')}</label>
          <select value={segment} onChange={(e) => setSegment(e.target.value)}>
            <option value="all">{t('notifications.allUsers')}</option>
            <option value="byLevel">{t('notifications.byLevel')}</option>
          </select>
        </div>
        <div className="resources-form-group">
          <label>Message (optional)</label>
          <textarea value={message} onChange={(e) => setMessage(e.target.value)} rows={3} placeholder="e.g. New exams for Primary and Middle School are now available." />
        </div>
        <div className="resources-form-actions">
          <button type="button" className="action-btn" onClick={handleSend} disabled={sending}>{t('notifications.sendNotify')}</button>
          {result && <span className="resources-form-result">{result}</span>}
        </div>
      </div>
    </div>
  );
};

export default NotificationsTab;
